export default __webpack_public_path__ + "static/media/doctorWave2.b7de64c2.gif";